<div class="modal-header">
  <h5 class="modal-title">O que você está cursando?</h5>
</div>
<form>
  <div class="modal-body">
    <div class="form-row div-center">
      <span class="info">
        Esse pop-up será aberto novamente depois caso você o feche sem responder
      </span>
    </div>
    <div class="form-row">
      <div class="col form-group">
        <mat-form-field class="example-full-width" appearance="outline">
          <mat-label>Selecione uma opção</mat-label>
          <mat-select (selectionChange)="changeSelected($event.value)">
            <mat-option
              *ngFor="let option of attendingOptions"
              [value]="option.value"
            >
              {{ option.viewText }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      mat-raised-button
      type="button"
      class="btn btn-link"
      (click)="dialogRef.close()"
    >
      Voltar
    </button>
    <button
      mat-raised-button
      type="submit"
      btnloader
      class="btn btn-primary"
      [mat-dialog-close]="data"
      (click)="save()"
    >
      Salvar
    </button>
  </div>
</form>
